<template>
  <div class="snail_hlw_page">
    <!-- 活动标题 -->
    <div v-wechat-title="'最强蜗牛-爷（蜗）爷，你关注的神域终于更新啦！'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-snail' v-show='preloadingShow'></div>
    </transition>
    <div class="snail-hlw-content">

      <div class="swiper-container " ref="mySwiper">
        <div :class="'swiper-wrapper device-510-' + isHeightLessThan510">
          <div class="swiper-slide slide-page-1">
            <div class="slogan" data-swiper-parallax="-500"></div>
            <div class="snail-btn" @click="popSwitch('secretOrdersShow', true)"></div>
            <div class="rule-box">
              <a href="javascript:;" class="rule-btn" @click="popSwitch('ruleShow', true)"></a>
            </div>
            <div class="download-box">
              <a href="javascript:;" class="download-btn" @click="downloadLink()"></a>
            </div>
            <div class="mark-l"></div>
            <div class="mark-r"></div>
            <div class="arrow" @click="navTab(1)"></div>
          </div>
          <div class="swiper-slide slide-page-2">
            <div class="title" data-swiper-parallax="-500"></div>
            <div class="main" data-swiper-parallax="-700">
              <div :class="'drawer-box drawer-box-' + drawerChanges">
                <div class="drawer drawer-1" @click="drawerNum(1)">
                  <div class="name name-1"></div>
                  <div class="img-box">
                    <img src="../../../../assets/images/active/snail/hlw/banner_1.png">
                  </div>
                </div>
                <div class="drawer drawer-2" @click="drawerNum(2)">
                  <div class="name name-2"></div>
                  <div class="img-box">
                    <img src="../../../../assets/images/active/snail/hlw/banner_2.png">
                  </div>
                </div>
                <div class="drawer drawer-3" @click="drawerNum(3)">
                  <div class="name name-3"></div>
                  <div class="img-box">
                    <img src="../../../../assets/images/active/snail/hlw/banner_3.png">
                  </div>
                </div>
              </div>
            </div>
            <div class="altar">
              <div class="role-0"></div>
            </div>
          </div>
          <div class="swiper-slide slide-page-3">
            <div class="title" data-swiper-parallax="-500"></div>
            <div class="banner-box" data-swiper-parallax="-700"></div>
            <div class="swiper-banner" data-swiper-parallax="-700">
              <a class="play-btn" href="javascript:;" @click="popSwitch('videoShow', true)"></a>
            </div>
            <div class="altar">
              <div class="role-1"></div>
              <div class="role-2"></div>
              <div class="cloud"></div>
            </div>
          </div>
          <div class="swiper-slide slide-page-4">
            <div class="title" data-swiper-parallax="-500"></div>
            <div class="invite-box" data-swiper-parallax="-700">
              <div class="reward-icon">
                <a :class="'btn-' + item.number + ' btn-get-' + item._get + ' btn-is-' + item.is_get"
                  v-for="(item, index) in invite_reward_info" :key="index" href="javascript:;"
                  @click="inviteReward(item._get, item.is_get, Number(index + 1));"></a>
              </div>
            </div>
            <div class="invite-list" data-swiper-parallax="-700">
              <ul>
                <li v-for="(item, index) in yqhyList" :key="index">
                  <b v-if="item.nickname !== ''" class="b-name">{{ item.nickname }}</b>
                  <b v-else class="b-null" @click="addFriends(item.nickname)">{{ item.nickname }}</b>
                </li>
              </ul>
            </div>
            <div class="invite-btn" data-swiper-parallax="-700">
              <a href="javascript:;" @click="addFriends()"></a>
            </div>
            <div class="altar"></div>
            <div class="role-3"></div>
          </div>
          <div class="swiper-slide slide-page-5">
            <div class="title" data-swiper-parallax="-500"></div>
            <div class="hlw-role" data-swiper-parallax="-700" @click="popSwitch('hlwSwiperShow', true)">
              <div></div>
            </div>
            <div class="altar">
              <div class="role-4"></div>
              <div class="role-5"></div>
              <div class="cloud"></div>
            </div>
          </div>

          <div class="swiper-slide slide-page-6">
            <div class="title" data-swiper-parallax="-500"></div>
            <div class="main" data-swiper-parallax="-700">
              <div class="award-records">
                <a class="award-records-btn" href="javascript:;" @click="popSwitch('rewardListShow', true)"></a>
              </div>
              <div class="draw-box">
                <div class="draw-list">
                  <ul :class="'ul-' + randomNumber">
                    <li :class="'li-' + item.id" v-for="(item, index) in drawList" :key="index"></li>
                  </ul>
                </div>
              </div>
              <div class="btn-box">
                <div class="top-box">
                  <a class="l-btn" href="javascript:;" @click="lotteryBtn()"></a>
                  <a class="r-btn" href="javascript:;" @click="drawLotteryNumber()"></a>
                </div>
                <div class="center-info">
                  还有<strong>{{ times }}</strong>次抽奖机会
                </div>
              </div>
            </div>
            <div class="altar"></div>
            <div class="role-6"></div>
          </div>

          <div class="swiper-slide slide-page-7">
            <div class="title" data-swiper-parallax="-500"></div>
            <div class="main" data-swiper-parallax="-700">
              <a href="javascript:;" class="gzh-btn"
                @click="goLine('https://mp.weixin.qq.com/s/GaLXxuby2UX_Je1yDs8ORw', '蜗牛_神域_葫芦娃h5_点击跳转公众号文章')"></a>
              <a href="javascript:;" class="taptap-btn"
                @click="goLine('https://tap.cn/sR98aik0?channel=rep-rep_dl8tyf30fh6', '蜗牛_神域_葫芦娃h5_点击跳转taptap')"></a>
            </div>
            <div class="altar"></div>
            <div class="role-9"></div>
          </div>

          <div class="swiper-slide foot-page">
            <Footer :gameName="gameName" />
          </div>
        </div>
      </div>

      <div :class="'nav nav-' + swiperActiveIndex" title="右侧悬浮导航">
        <a v-for="i in 7" :key="i" :class="'nav-link-' + i" href="javascript:;" @click="navTab(i)"></a>
      </div>
    </div>

    <!-- 分享相关DOM -->
    <div class="share-box-hlw" ref="imageDom">
      <img src="../../../../assets/images/active/snail/hlw/popup/share_pop.png" />
      <div class="share-img">
        <div class="url-box"></div>
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
      </div>
    </div>

    <Header :config="headerConfig" :isShowInfo="true" :isOnline="1" />
    <!-- 所有弹窗 -->
    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :loginTypes="loginTypes"
      :downloadUrl="downloadUrl" channelTips="角色UID可在游戏中—设置—UID查看" noAuthLogin></Login>
    <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"></Os>

    <!-- 规则弹窗 -->
    <div :class="'rule-wrap popup_wrap rule-wrap-' + ruleShow" v-show="ruleShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="rule-box popup_wrap-box" v-show="ruleShow"></div>
      </transition>
      <div class="close-bg" @click="popSwitch('ruleShow', false)"></div>
    </div>

    <!-- 密令弹窗 -->
    <div :class="'secret-orders-wrap popup_wrap secret-orders-wrap-' + secretOrdersShow" v-show="secretOrdersShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="secret-orders-box popup_wrap-box" v-show="secretOrdersShow">
          <a class="secret-orders-btn" href="javascript:;" @click="popSwitch('secretOrdersShow', false)"></a>
        </div>
      </transition>
      <div class="close-bg" @click="popSwitch('secretOrdersShow', false)"></div>
    </div>

    <!-- 葫芦娃轮播弹窗 -->
    <div :class="'hlw-swiper-wrap popup_wrap hlw-swiper-wrap-' + hlwSwiperShow" v-show="hlwSwiperShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="hlw-swiper-box popup_wrap-box" v-show="hlwSwiperShow">
          <div class="swiper-container-2 " ref="mySwiper-2">
            <div class="swiper-wrapper">
              <div class="swiper-slide slide-page-1">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_1.png"></div>
              </div>
              <div class="swiper-slide slide-page-2">
                <div class="slide-box"><i @click="eggReward(1)"></i><img
                    src="../../../../assets/images/active/snail/hlw/popup/introduce_2.png"></div>
              </div>
              <div class="swiper-slide slide-page-3">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_3.png"></div>
              </div>
              <div class="swiper-slide slide-page-4">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_4.png"></div>
              </div>
              <div class="swiper-slide slide-page-5">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_5.png"></div>
              </div>
              <div class="swiper-slide slide-page-6">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_6.png"></div>
              </div>
              <div class="swiper-slide slide-page-7">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_7.png"></div>
              </div>
              <div class="swiper-slide slide-page-8">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_8.png"></div>
              </div>
              <div class="swiper-slide slide-page-9">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_9.png"></div>
              </div>
              <div class="swiper-slide slide-page-10">
                <div class="slide-box"><i @click="eggReward(2)"></i><img
                    src="../../../../assets/images/active/snail/hlw/popup/introduce_10.png"></div>
              </div>
              <div class="swiper-slide slide-page-11">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_11.png"></div>
              </div>
              <div class="swiper-slide slide-page-12">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_12.png"></div>
              </div>
              <div class="swiper-slide slide-page-13">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_13.png"></div>
              </div>
              <div class="swiper-slide slide-page-14">
                <div class="slide-box"><img src="../../../../assets/images/active/snail/hlw/popup/introduce_14.png"></div>
              </div>
              <div class="swiper-slide slide-page-15">
                <div class="slide-box"><i @click="eggReward(3)"></i><img
                    src="../../../../assets/images/active/snail/hlw/popup/introduce_15.png"></div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="close-btn" @click="popSwitch('hlwSwiperShow', false)"></div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 视频弹窗 -->
    <div :class="'video-wrap popup_wrap video-wrap-wrap-' + videoShow" v-show="videoShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="video-box">
          <video ref="videoRef" v-show="videoShow"
            src="https://download4.qcplay.com/qcgame-admin/SYoHMHBDcml01lDZunnX2abv8WFrDMEOuBwr3Q5P.mp4"
            @ended="videoShow = false" controls></video>
        </div>
      </transition>
      <div class="close-bg" @click="popSwitch('videoShow', false)"></div>
    </div>


    <!-- 分享弹窗 -->
    <div :class="'help-share-wrap popup_wrap help-share-wrap-' + shareShow">
      <div class="help-share-box popup_wrap-box">
        <div class="bottom-img">
          <div class="qrcode-box">
            <div id="qrcode2" class="qrcode"></div>
          </div>
        </div>
        <img :src="shareImg" alt="分享图片" />
        <button class="monitor-btn" @click="onCopy('#clipboard-btn')" id="clipboard-btn" data-event="复制邀请链接"
          :data-clipboard-text="clipInfo + shareLink"></button>
        <div class="close-bg" v-show="shareShow" @click="popSwitch('shareShow', false)"></div>
      </div>
    </div>

    <!-- 抽奖弹窗 -->
    <div :class="'reward-wrap popup_wrap reward-wrap-' + rewardShow" v-show="rewardShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="reward-box popup_wrap-box" v-show="rewardShow">
          <dl class="icon-info">
            <dt :class="'dt-' + randomNumber"></dt>
            <dd>
              <h4>恭喜蜗爷获得</h4>
              <p>【<span>{{ rewardName }}</span>】</p>
            </dd>
          </dl>
          <a class="confirm-btn" href="javascript:;" @click="popSwitch('rewardShow', false)"></a>
        </div>
      </transition>
    </div>

    <!-- 奖励信息弹窗 -->
    <div :class="'reward-list-wrap popup_wrap reward-list-wrap-' + rewardListShow" v-show="rewardListShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="reward-list-box popup_wrap-box" v-show="rewardListShow">
          <div class="list">
            <h2>
              <strong>奖品名称</strong>
              <strong>获奖时间</strong>
            </h2>
            <div v-if="record_list.length == 0">暂无数据</div>
            <ul v-else>
              <li v-for="(item, index) in record_list" :key="index"><span>{{ item.remark }}</span><span>{{ item.created_at
              }}</span></li>
            </ul>
          </div>
          <a class="confirm-btn" href="javascript:;" @click="popSwitch('rewardListShow', false)"></a>
        </div>
      </transition>
    </div>

    <!-- 任务弹窗 -->
    <div :class="'task-wrap popup_wrap task-wrap-' + taskShow" v-show="taskShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div class="task-box popup_wrap-box" v-show="taskShow">
          <div class="task-list">
            <li v-for="(item, index) in task_info" :key="index">
              <a v-if="item.is_get" :class="'task-' + index + '-btn reach-btn'" href="javascript:;" title="领取过-已达成"></a>
              <a v-if="!item.is_get" :class="'task-' + index + '-btn no-reach-btn'" href="javascript:;" title="没领取过"
                @click="participatingTask(index, item.link)"></a>
            </li>
          </div>
          <a class="confirm-btn" href="javascript:;" @click="popSwitch('taskShow', false)"></a>
        </div>
      </transition>
    </div>

    <!-- 彩蛋弹窗 -->
    <div :class="'egg-reward-wrap popup_wrap egg-reward-wrap-' + eggRewardShow" v-show="eggRewardShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div :class="'egg-reward-box popup_wrap-box egg-' + egg_id + ' egg-' + egg_state" v-show="eggRewardShow">
          <a class="confirm-btn" href="javascript:;" @click="popSwitch('eggRewardShow', false)"></a>
        </div>
      </transition>
    </div>

    <!-- 好友组队头像相关弹窗 -->
    <div :class="'pic-reward-wrap popup_wrap pic-reward-wrap-' + picRewardShow" v-show="picRewardShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" :duration="{ enter: 1000 }">
        <div :class="'pic-reward-box popup_wrap-box pic-' + picRewardNum" v-show="picRewardShow">
          <a class="share-btn" href="javascript:;" @click="picShare()"></a>
          <a class="confirm-btn" href="javascript:;" @click="popSwitch('picRewardShow', false)"></a>
        </div>
      </transition>
    </div>

    <!-- 提示弹窗 -->
    <div :class="'tips-wrap tips-wrap-' + tipsShow">
      <div :class="'show-' + tipsShow2">
        <p>{{ tips }}</p>
      </div>
    </div>

    <!-- 阻止点击弹出-弹窗 -->
    <div @touchmove.prevent :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

  </div>
</template>
<script>

import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header/index';
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import { swiper } from 'vue-awesome-swiper'
import Clipboard from 'clipboard';
import { onGetInitDataAPI, lotteryDataAPI, taskDataAPI, eggRewardDataAPI, teamInviteDataAPI } from '../api';
import { getRandomString, getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
const commonConfig = {
  resistanceRatio: 0,
  mousewheelControl: true,
  speed: 500,
  parallax: true,
  slidesPerView: 'auto',
  lazyLoading: true,
  lazyLoadingInPrevNext: true,
  preloadImages: false,
  observer: true,
  observeParents: true,
};
export default {
  name: 'hlw',
  components: {
    swiper,
    Header,
    Footer,
    Login,
    Os
  },
  data() {
    return {
      headerConfig,
      gameName: "snail",
      loginTypes: ["sms", "password", "channel"],
      downloadUrl: 'http://snail.qingcigame.com/official/',
      taptapUrl: 'https://tap.cn/tm3lTYBt?channel=rep-rep_nlo5ha7ptsr',
      preloadingShow: false,
      titleShow: false,
      swiperActiveIndex: 0,
      drawList: [
        { id: 1, select: 1 },
        { id: 2, select: 0 },
        { id: 3, select: 0 },
        { id: 4, select: 0 },
        { id: 5, select: 0 },
        { id: 6, select: 0 },
        { id: 7, select: 0 },
        { id: 8, select: 0 },
        { id: 9, select: 0 }
      ],
      randomNumber: 1,  // 默认随机按钮
      egg_id: 1,  // 彩蛋id
      egg_state: false, // 彩蛋状态
      rewardName: '',
      yqhyList: [
        { avatar: '', nickname: '' },
        { avatar: '', nickname: '' },
        { avatar: '', nickname: '' }
      ],
      picRewardNum: 1,  // 组队后领取头像
      iconNumber: 0,  // 参与头像数量
      times: 3, // 抽奖次数
      record_list: [],  // 中奖信息
      task_info: [],  // 任务列表
      invite_reward_info: [
        { package_id: 530, number: 1, is_get: false, _get: false },
        { package_id: 531, number: 3, is_get: false, _get: false }
      ], // 组队奖励信息
      drawerChanges: 1, // 抽屉效果1
      active_Info: {}, // 活动信息
      user_info: {}, // 用户信息
      isUserInfo: false, // 是否获取用户信息
      shareLink: '',
      // 复制使用的文案
      clipInfo: '',
      params: '',
      url_type: '',
      shareImg: null,
      preventShow: false,
      paymentTipsShow: false,
      shareShow: false,
      rewardShow: false,
      rewardListShow: false,
      videoShow: false,
      taskShow: false,
      eggRewardShow: false,
      swiper: null,
      ruleShow: false,
      secretOrdersShow: false,
      hlwSwiperShow: false,
      picRewardShow: false,
      // 提示语
      tips: '',
      // 提示显示1
      tipsShow: false,
      // 提示显示2
      tipsShow2: false,
      // 高度是否超过510px
      isHeightLessThan510: false,
    };
  },
  created() {
    setTimeout(() => {
      this.getLoginContainer();
      this.setInitActiveInfo();
      this.setInitUserInfo();
    }, 100);
  },
  mounted() {
    this.$nextTick(() => {

      // 分享
      this.params = analysisParams(window.location.href);
      this.url_type = this.params.type;
      const { protocol, host } = window.location;
      const enterLink = `${protocol}//${host}/snail/hlw/enter${getRandomString()}`;
      const pcLink = `${protocol}//${host}/snail/hlw/pc`;
      this.monitoringEquipment(pcLink);
      this.isSetShare(enterLink);

      // 兼容屏幕高度
      this.checkScreenHeight();
      window.addEventListener('resize', this.checkScreenHeight);

      // 埋点
      const bl = buriedLogger('snail', '蜗牛_神域_葫芦娃h5');
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum('蜗牛_神域_葫芦娃h5_活动页统计');
      }, 200);
    })
    this.hlwSwiper();
    this.hlwSwiper2();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenHeight);
  },
  methods: {
    monitoringEquipment(pcLink) {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = pcLink;
    },
    checkScreenHeight() {
      this.isHeightLessThan510 = window.innerHeight < 510;
    },
    hlwSwiper() {
      var _this = this;
      new Swiper('.swiper-container', {
        ...commonConfig,
        direction: 'vertical',
        onInit: function (swiper) {
          _this.swiper = swiper;
          _this.swiperActiveIndex = swiper.activeIndex;
        },
        onSlideChangeEnd: function (swiper) {
          _this.swiperActiveIndex = swiper.activeIndex;
        },
      });
    },
    hlwSwiper2() {
      new Swiper('.swiper-container-2', {
        ...commonConfig,
        spaceBetween: 100,
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
      });
    },
    // 点击下载
    downloadLink() {

      if (this.url_type == '' || this.url_type == undefined) {
        this.logger.sum('蜗牛_神域_葫芦娃h5_点击首屏下载按钮');
        setTimeout(() => {
          window.location.href = this.taptapUrl;
        }, 200);
      } else {
        this.logger.sum('蜗牛_神域_葫芦娃h5_点击首屏下载按钮(qc-kol-1145353)');
        setTimeout(() => {
          window.location.href = '//download4.qcplay.com/apk-v2/' + this.url_type + '.apk';
        }, 200);
      }

    },
    // 导航按钮
    navTab(num) {
      this.swiper.slideTo(num, 500, true)
    },
    // 获取抽奖次数
    drawLotteryNumber() {
      if (this.user_info.share_account === undefined || this.user_info.share_account === '') {
        this.changeLoginPopup(true);
        return
      }
      this.logger.sum('蜗牛_神域_葫芦娃h5_点击获取抽奖次数按钮');
      this.popSwitch('taskShow', true);
    },
    // 弹窗状态-开or关
    popSwitch(name, state) {
      // 奖励列表
      if ((name == 'rewardListShow' && state)) {
        if (this.user_info.share_account === undefined || this.user_info.share_account === '') {
          this.changeLoginPopup(true);
        } else {
          this[name] = state;
        }
        return
      }
      // pv视频
      if (name == 'videoShow') {
        state ? this.$refs.videoRef.play() : this.$refs.videoRef.pause();
        if (state) {
          this.logger.sum('蜗牛_神域_葫芦娃h5_点击观看pv');
        }
      }
      // 抽奖次数弹窗
      if (name == 'taskShow') {
        if (!state) {
          this.getLoginContainer();
        }
      }

      this[name] = state;
    },
    // 抽屉效果
    drawerNum(num) {
      this.drawerChanges = num;
    },
    // 复制链接
    onCopy(copyName) {
      var _this = this;
      // 任务一
      this.taskType(1);
      const clipboard = new Clipboard(copyName);
      clipboard.on('success', (e) => {
        _this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        _this.onToast('复制失败');
      });
      this.logger.sum('蜗牛_神域_葫芦娃h5，复制成功');
    },
    // 任务类型
    taskType(type_id) {
      taskDataAPI({ task_id: type_id })
        .then(response => {
          if (Number(response.code) === 200) {
            this.getLoginContainer();
            return
          }
          if (type_id == 1) return
          this.onToast(response.message)
          this.preventShow = false;
        }).catch((err) => {
          this.onToast('服务器出错啦')
        })
    },
    // 邀请好友按钮
    addFriends(nick_name) {
      if (this.user_info.share_account === undefined || this.user_info.share_account === '') {
        this.changeLoginPopup(true);
        return
      }
      Indicator.open();
      this.preventShow = true;
      setTimeout(() => {
        const { protocol, host } = window.location;
        this.clipInfo = '爷（蜗）爷，你关注的神域终于更新啦！' + this.user_info.share_account.substr(-4) + '邀请你加入小队，快来跟蜗一起，揭开神域的层层真相：';
        this.shareLink = `${protocol}//${host}/snail/hlw/help${getRandomString()}?friend_id=` + this.user_info.user_id;
        this.initShareData();
        this.logger.sum('蜗牛_神域_葫芦娃h5_点击邀请按钮');
      }, 10);
    },
    initShareData() {
      try {
        this.generateQRCodeById('qrcode', this.shareLink);
        this.generateQRCodeById('qrcode2', this.shareLink);
        this.$nextTick(() => {
          this.generateShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    // 分享图片设置
    generateShareImage() {
      if (this.$refs.imageDom !== undefined) {
        generateCanvasImage(this.$refs.imageDom)
          .then((canvas) => {
            console.log(canvas, 'canvas')
            this.preventShow = false;
            this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
            console.log('success: 图片生成成功');
            this.shareShow = true;
            Indicator.close();
          })
          .catch((err) => {
            this.preventShow = false;
            Indicator.close();
            console.log('err: 图片生成失败', err.message);
          });
      }
    },
    // 点击抽奖按钮
    lotteryBtn() {
      if (this.user_info.share_account === undefined || this.user_info.share_account === '') {
        this.changeLoginPopup(true);
        return
      }
      this.preventShow = true;
      lotteryDataAPI().then(response => {
        if (Number(response.code) === 200) {
          this.logger.sum('蜗牛_神域_葫芦娃h5_点击抽奖按钮');
          this.rewardName = response.data.title;
          this.randomDrawing(response.data.prize_id);
          this.getLoginContainer();
          return
        }
        this.onToast(response.message)
        this.preventShow = false;
      }).catch((err) => {
        this.onToast('服务器出错啦')
      })
    },
    // 随机抽奖
    randomDrawing(prize_id) {
      let prevNum = null;
      let count = 0;
      let countMax = 50;
      let interval = 100; // 初始速度为2秒一次
      let intervalId = null;
      var _this = this;

      function getRandomNum(min, max) {
        let num = Math.floor(Math.random() * (max - min + 1)) + min;
        if (num === prevNum) {
          return getRandomNum(min, max);
        }
        return num;
      }

      function setRandomNum() {
        if (count === countMax) {
          clearInterval(intervalId);
          _this.randomNumber = prize_id;
          setTimeout(() => {
            _this.rewardShow = true;
          }, 200);
          _this.preventShow = false;
          return;
        }

        if (count === Math.floor(countMax / 3)) {
          clearInterval(intervalId);
          interval = 100; // 中间三分之一的速度是1秒一次
          intervalId = setInterval(setRandomNum, interval);
        } else if (count === Math.floor(2 * countMax / 3)) {
          clearInterval(intervalId);
          interval = 150; // 最后三分之一速度是2秒一次
          intervalId = setInterval(setRandomNum, interval);
        }

        prevNum = getRandomNum(1, 9);
        _this.randomNumber = prevNum;
        count++;
      }

      intervalId = setInterval(setRandomNum, interval);
    },
    // 是否领取过奖励
    participatingTask(id, url) {
      if (this.user_info.share_account === undefined || this.user_info.share_account === '') {
        this.changeLoginPopup(true);
        return
      }
      // 任务一
      if (id == 0) {
        this.logger.sum('蜗牛_神域_葫芦娃h5_点击任务一按钮');
        this.addFriends();
      }
      // 任务三
      if (id == 2) {
        this.logger.sum('蜗牛_神域_葫芦娃h5_点击任务三按钮');
        window.location = url;
      }
    },
    // 彩蛋密令
    eggReward(id) {
      if (this.user_info.share_account === undefined || this.user_info.share_account === '') {
        this.changeLoginPopup(true);
        this.popSwitch('hlwSwiperShow', false);
        return
      }
      // 请求彩蛋api
      this.eggType(id);
    },
    // 彩蛋类型
    eggType(type_id) {
      Indicator.open();
      this.preventShow = true;
      eggRewardDataAPI({ package_id: type_id })
        .then(response => {
          setTimeout(() => {
            if (Number(response.code) === 200 || Number(response.code) === 405) {
              this.egg_id = type_id;
              this.preventShow = false;
              this.popSwitch('eggRewardShow', true);
              Indicator.close();
            }
            if (Number(response.code) === 200) {
              this.egg_state = false;
              return
            }
            if (Number(response.code) === 405) {
              this.egg_state = true;
              return
            }
            this.onToast(response.message);
            setTimeout(() => {
              this.preventShow = false;
            }, 1500);
          }, 1000);
        }).catch((err) => {
          this.onToast('服务器出错啦')
          Indicator.close();
        })
    },
    // 组队奖励
    inviteReward(_get, is_get, id) {
      if (this.user_info.share_account === undefined || this.user_info.share_account === '') {
        this.changeLoginPopup(true);
        return
      }
      if (_get) {
        if (!is_get) {
          // 组队奖励领取
          this.teamInviteReward(id);
        } else {
          this.onToast('您已领取过奖励，无需重复领取！');
        }
      }
    },
    // 组队奖励领取
    teamInviteReward(type_id) {
      teamInviteDataAPI({ package_id: type_id })
        .then(response => {
          if (Number(response.code) === 200) {
            this.picRewardNum = type_id;
            this.picRewardShow = true;
            this.getLoginContainer();
            return
          }
          this.onToast(response.message)
        }).catch((err) => {
          this.onToast('服务器出错啦');
          Indicator.close();
        })
    },
    // 头像奖励中的分享
    picShare() {
      this.popSwitch('picRewardShow', false);
      this.addFriends();
    },
    // 前往重定向
    goLine(url, loggerName) {
      if (url == '') {
        this.onToast('敬请期待！');
        return
      }
      this.logger.sum(loggerName);
      setTimeout(() => { window.location.href = url }, 200);
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '爷（蜗）爷，你关注的神域终于更新啦！',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/Hmpg68XTBbVFL9n0HyLdNp48EdiWf8mCBSx2naIz.png',
        desc: '快来跟蜗一起，揭开神域的层层真相！',
      })
    },
    // 二维码生成
    generateQRCodeById(id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    // 获取用户信息
    getLoginContainer() {
      onGetInitDataAPI().then(response => {
        if (Number(response.code) === 200) {
          this.active_Info = response.data.activity || [];
          this.user_info = response.data.user_info || [];

          this.yqhyList = response.data.activity.team_info;
          this.times = response.data.activity.times;
          this.iconNumber = response.data.activity.number;
          this.record_list = response.data.activity.record_list;
          this.task_info = response.data.activity.task_info;
          this.invite_reward_info = response.data.activity.invite_reward_info;

          this.onInitDataCallback(response);
          return
        }
        Number(response.code) !== 401 && this.onToast(response.message)
      }).catch((err) => {
        this.onToast('服务器出错啦')
      })
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.active_Info = [];
      this.user_info = [];
      this.yqhyList = [
        { avatar: '', nickname: '' },
        { avatar: '', nickname: '' },
        { avatar: '', nickname: '' }
      ];
      this.isUserInfo = true;
      this.times = 3;
      this.iconNumber = 0;
      this.record_list = [];
      this.task_info = [];
      this.invite_reward_info = [
        { package_id: 530, number: 1, is_get: false, _get: false },
        { package_id: 531, number: 3, is_get: false, _get: false }
      ];
    },
    // 选择角色后
    selectCallback() {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
      });
    },
    // TAG: 相关业务方法
    onInvite() {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
    },
    // 注销
    osCancell() {
      this.clearActiveInfo();
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    tipsMessage(message, times) {
      this.tipsShow = true
      this.tips = message
      setTimeout(() => { this.tipsShow2 = true }, 100)
      setTimeout(() => { this.tipsShow2 = false }, times - 200)
      setTimeout(() => { this.tipsShow = false; this.tips = ''; }, times)
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          console.log('注销的时候')
          this.osCancell()
        } else if (
          newValue.role_id !== oldValue.role_id ||
          newValue.account !== oldValue.account
        ) {
          // 数据初始化
          this.getLoginContainer()
        }
      }
    }
  },
};
</script>

<style lang="less">@import url("./index.less");</style>
 


// WEBPACK FOOTER //
// src/pages/snail/hlw/index/index.vue